<script setup lang="ts">
import ImportTutorPaymentsUploader from './tutor-payments/ImportTutorPaymentsUploader.vue'

defineOptions({
  name: 'ToolsImportTutorPaymentsPage',
})
</script>

<template>
  <ImportTutorPaymentsUploader />
</template>
